/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var LocalAccountTypes;
(function (LocalAccountTypes) {
    LocalAccountTypes[LocalAccountTypes["NUMBER_0"] = 0] = "NUMBER_0";
    LocalAccountTypes[LocalAccountTypes["NUMBER_1"] = 1] = "NUMBER_1";
    LocalAccountTypes[LocalAccountTypes["NUMBER_2"] = 2] = "NUMBER_2";
    LocalAccountTypes[LocalAccountTypes["NUMBER_3"] = 3] = "NUMBER_3";
})(LocalAccountTypes || (LocalAccountTypes = {}));
export function LocalAccountTypesFromJSON(json) {
    return LocalAccountTypesFromJSONTyped(json, false);
}
export function LocalAccountTypesFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function LocalAccountTypesToJSON(value) {
    return value;
}
